import { CircularProgress, Stack, Typography } from '@mui/material'
import { useLazyGetFavoriteGrowthToolsPageQuery } from '../../../../api/growthTools'
import { GrowthToolsList } from '../../../../components/GrowthTools/GrowthToolsList'
import { useGrowthToolsQueryArgs } from '../../../../hooks/useGrowthToolsQueryArgs'
import { useGrowthToolsWindowedPage } from '../../../../hooks/useGrowthToolsWindowedPage'

export const GrowthToolsSubscriptions = () => {
  const { queryArgs, resetKey } = useGrowthToolsQueryArgs()
  const [loadGrowthToolsPage] = useLazyGetFavoriteGrowthToolsPageQuery()
  const { items, hasMore, isInitialLoading, isFetchingMore, isError, loadMore } =
    useGrowthToolsWindowedPage(resetKey, loadGrowthToolsPage, queryArgs)

  if (isInitialLoading && items.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight="100%">
        <CircularProgress />
      </Stack>
    )
  }

  if (isError) {
    return (
      <Typography color="error" textAlign="center" px={2}>
        Не удалось загрузить избранные инструменты роста
      </Typography>
    )
  }

  return (
    <GrowthToolsList
      growthTools={items}
      hasMore={hasMore}
      isLoadingMore={isFetchingMore}
      onLoadMore={loadMore}
      emptyMessage="Здесь будут избранные инструменты роста"
    />
  )
}
